import Phaser from "phaser";
import SoundManager from "../sound/SoundManager";
import SoundButton from "../ui/soundButton";
import SceneUtils from "../utils/sceneUtils";
import {setupButtonClick} from "../utils/ui";
import HighscorePanel from "../ui/highscorePanel";
import CreditsPanel from "../ui/creditsPanel";
import MobileInputProvider from "../controller/mobileInputProvider";
import NameInput from "../ui/nameInput";
import LocalStorage from "../utils/localStorage";
import BaseScene from "./baseScene";
import TwoFX from "../fx/twoFX";
import buildConfig from "../../buildConfig";

export default class Menu extends BaseScene
{
    constructor ()
    {
        super('Menu');
    }

    preload ()
    {
        MobileInputProvider.preload(this);
        TwoFX.preload(this);
        this.load.image('board', 'src/assets/img/board2.png');
        this.load.image('background', 'src/assets/img/star_fire.jpg');
        this.load.image('title', 'src/assets/img/logo.png');
        this.load.image('brand', 'src/assets/img/brand-min.png');
        this.load.image('btn_home', 'src/assets/img/home_btn.png');
        this.load.image('name_background', 'src/assets/img/board3.png');
        SoundButton.preload(this);
    }

    create ()
    {
        super.create();
        TwoFX.init(this);
        SoundManager.playMusic("intro", true);
        this.createUI();
        this.scale.on("resize", () => SceneUtils.resize(this));
        SceneUtils.resetThree(this.game.threeScene);
    }

    createUI(){
        const offsetY = 0;

        const frontImage = this.add.image(this.scale.width / 2 , this.scale.height / 2,"background");

        frontImage.setDepth(-1);

        this.boardImg = this.add.image(this.scale.width / 2 , this.scale.height /2 +offsetY,"board");
        this.boardImg.setScale(0.6);

        const title = this.add.image(this.scale.width / 2 + 10, this.scale.height / 6  +offsetY,"title");
        title.setScale(1.15);
        title.setOrigin(0.5);


        const frameEmitter = TwoFX.createFrameEmitter(title.getBounds());
        frameEmitter.setDepth(10);
        TwoFX.emitLeaves(frameEmitter);

        this.menuText = this.add.text(this.scale.width / 2, this.scale.height /3  +offsetY, "Menu",
            { fontFamily: 'Splurge', fontSize: 60, align: "center", fill: "#141" }
        )
        this.menuText.setOrigin(0.5)

        this.startText = this.add.text(this.scale.width / 2, this.scale.height /2 - 100  +offsetY, "Start",
            { fontFamily: 'Splurge', fontSize: 60, align: "center", fill: "#DDD" }
        )
        this.startText.setOrigin(0.5);

        setupButtonClick(this.startText, () => this.onStartClick())

        this.creditsText = this.add.text(this.scale.width / 2, this.scale.height /2 + 100  +offsetY, "Credits",
            { fontFamily: 'Splurge', fontSize: 60, align: "center", fill: "#DDD" }
        )
        this.creditsText.setOrigin(0.5);

        this.creditsPanel = new CreditsPanel({scene: this});

        setupButtonClick(this.creditsText, () => this.onCreditsClick())

        this.highscoreText = this.add.text(this.scale.width / 2, this.scale.height /2 +offsetY, "Highscore",
            { fontFamily: 'Splurge', fontSize: 60, align: "center", fill: "#DDD" }
        )
        this.highscoreText.setOrigin(0.5);

        setupButtonClick(this.highscoreText, () => this.onHighscoreClick())

        this.highscorePanel = new HighscorePanel({scene: this});

        this.nameBackground = this.add.image(130 , 20 + offsetY,"name_background");

        this.nameBackground.rotation = Math.PI

        this.nameBackground.setScale(0.5, 0.5);

        this.insertNameText = this.add.text(20, 50 +offsetY, "Name:",
            { fontFamily: 'Splurge', fontSize: 40, align: "center", fill: "#AAA" }
        )
        this.insertNameText.setOrigin(0, 0.5);

        this.nameInput = new NameInput({
            scene: this,
            x: 420,
            y: 50,
            width: 550,
            fontSize: 40,
            color: "#DDD",
            text: LocalStorage.getPlayerName(),
            labelText: "Name:",
            onUpdate: (text) => {
                if(text.length > 3 && text.length < 10){
                    LocalStorage.setPlayerName(text);
                }
            }
        });

        this.version = this.add.text(
            20,
            this.scale.height - 35,
            `${buildConfig.version}-${buildConfig.target}`,
            {font: "26px Splurge", fill: "#ddd"}
        );

        const brand = this.add.image(this.scale.width, this.scale.height ,"brand");
        brand.setScale(0.45);
        brand.setOrigin(1);

        //this.createTermsText();
    }

    createTermsText(){
        this.termsText = this.add.text(this.scale.width - 20, this.scale.height - 20, "Terms & Privacy",
            { fontFamily: 'Splurge', fontSize: 30, align: "center", fill: "#DDD" }
        )

        this.termsText.setOrigin(1);

        setupButtonClick(this.termsText, () => {
            this.cameras.main.fadeOut(500, 0, 0, 0);
            this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, (cam, effect) => {
                SceneUtils.startFullscreen(this);
                this.scene.start('TermsAndPrivacy');
            })
        })
    }

    onCreditsClick(){
        this.creditsPanel.show();
        this.creditsText.actived = false;
    }

    onHighscoreClick(){
        this.highscorePanel.show();
        this.highscoreText.actived = false;
    }

    onStartClick(){
        this.cameras.main.fadeOut(500, 0, 0, 0);
        this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, (cam, effect) => {
            SceneUtils.startFullscreen(this);
            this.scene.start('Game');
        })
    }

    update(){
        this.game.threeRenderer.render(this.game.threeScene, this.game.threeCamera);
    }

}